function replaceNewlineToBr(innerHTML) {
  if (typeof innerHTML !== 'string') {
    console.warn('Supplied innerHTML is not of type \'string\'')
    return ''
  }
  return innerHTML.replace(/\n/g, '<br>')
}

export { replaceNewlineToBr }



// WEBPACK FOOTER //
// ./src/utility/textToHTMLHelpers.js